import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import { last } from './util.js';

var TreeNodeContext = /*#__PURE__*/function () {
  function TreeNodeContext(_ref) {
    var absoluteIndex = _ref.absoluteIndex,
        ancestorIds = _ref.ancestorIds,
        hasDescenderByLevel = _ref.hasDescenderByLevel,
        id = _ref.id,
        parentId = _ref.parentId,
        treeContext = _ref.treeContext;

    _classCallCheck(this, TreeNodeContext);

    this.absoluteIndex = absoluteIndex;
    this.hasDescenderByLevel = hasDescenderByLevel;
    this.id = id;
    this.parentId = parentId;
    this.ancestorIds = ancestorIds;
    this.treeContext = treeContext;
  }

  _createClass(TreeNodeContext, [{
    key: "hasChildren",
    value: function hasChildren() {
      return this.getChildIds().length > 0;
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      var _this = this;

      return this.hasChildren() && this.getChildIds().every(function (childId) {
        return _this.treeContext.hiddenIds.has(childId);
      });
    }
  }, {
    key: "isExpanded",
    value: function isExpanded() {
      var _this2 = this;

      return this.hasChildren() && this.getChildIds().some(function (childId) {
        return !_this2.treeContext.hiddenIds.has(childId);
      });
    }
  }, {
    key: "isLastChild",
    value: function isLastChild() {
      var siblingsAndSelf = this.getSiblingsAndSelf();
      return siblingsAndSelf.indexOf(this.id) === siblingsAndSelf.length - 1;
    }
  }, {
    key: "getAriaExpanded",
    value: function getAriaExpanded() {
      if (!this.hasChildren()) {
        return void 0;
      }

      return this.isExpanded();
    }
  }, {
    key: "getAriaLevel",
    value: function getAriaLevel() {
      return this.ancestorIds.length + 1;
    }
  }, {
    key: "getAriaPosInSet",
    value: function getAriaPosInSet() {
      return this.getSiblingsAndSelf().indexOf(this.id) + 1;
    }
  }, {
    key: "getAriaRowIndex",
    value: function getAriaRowIndex() {
      return this.absoluteIndex + 1;
    }
  }, {
    key: "getAriaSetSize",
    value: function getAriaSetSize() {
      return this.getSiblingsAndSelf().length;
    }
  }, {
    key: "getNextSiblingId",
    value: function getNextSiblingId() {
      var siblingsAndSelf = this.getSiblingsAndSelf();
      var i = siblingsAndSelf.indexOf(this.id) + 1;
      return i > siblingsAndSelf.length - 1 ? void 0 : siblingsAndSelf[i];
    }
  }, {
    key: "getParentContext",
    value: function getParentContext() {
      return this.parentId ? this.treeContext.getNodeContext(this.parentId) : void 0;
    }
  }, {
    key: "getParentNode",
    value: function getParentNode() {
      return this.parentId ? this.treeContext.nodeById[this.parentId] : void 0;
    }
  }, {
    key: "getPrevSiblingId",
    value: function getPrevSiblingId() {
      var siblingsAndSelf = this.getSiblingsAndSelf();
      var i = siblingsAndSelf.indexOf(this.id) - 1;
      return i < 0 ? void 0 : siblingsAndSelf[i];
    }
  }, {
    key: "getChildIds",
    value: function getChildIds() {
      return this.treeContext.childIdsByParentId[this.id];
    }
  }, {
    key: "getSiblingsAndSelf",
    value: function getSiblingsAndSelf() {
      return this.parentId ? this.treeContext.childIdsByParentId[this.parentId] : [this.id];
    }
  }, {
    key: "traverseDepthFirst",
    value: function traverseDepthFirst(iteratee) {
      var _this3 = this;

      _traverseDepthFirst({
        id: this.id,
        childIdsByParentId: this.treeContext.childIdsByParentId
      }, function (descendantId) {
        if (descendantId !== _this3.id) {
          for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          iteratee.apply(void 0, [descendantId].concat(rest));
        }
      });
    }
  }]);

  return TreeNodeContext;
}();
var TreeContext = /*#__PURE__*/function () {
  function TreeContext(_ref2) {
    var hiddenIds = _ref2.hiddenIds,
        nodeById = _ref2.nodeById,
        nodeContextById = _ref2.nodeContextById,
        nodeIds = _ref2.nodeIds,
        nodes = _ref2.nodes,
        childIdsByParentId = _ref2.childIdsByParentId,
        rootIds = _ref2.rootIds;

    _classCallCheck(this, TreeContext);

    this.hiddenIds = hiddenIds;
    this.nodeById = nodeById;
    this.nodeContextById = nodeContextById;
    this.nodeIds = nodeIds;
    this.nodes = nodes;
    this.childIdsByParentId = childIdsByParentId;
    this.rootIds = rootIds;
  }

  _createClass(TreeContext, [{
    key: "getNextVisibleIndexByIndex",
    value: function getNextVisibleIndexByIndex() {
      var _this4 = this;

      this.nextVisibleIndexByIndex = this.nextVisibleIndexByIndex || this.nodeIds.reduce(function (acc, id, i) {
        var nextIndex = Math.min(i + 1, _this4.nodes.length - 1);
        acc[_this4.getNodeContext(id).absoluteIndex] = _this4.getNodeContext(_this4.nodeIds[nextIndex]).absoluteIndex;
        return acc;
      }, {});
      return this.nextVisibleIndexByIndex;
    }
  }, {
    key: "getPrevVisibleIndexByIndex",
    value: function getPrevVisibleIndexByIndex() {
      var _this5 = this;

      this.prevVisibleIndexByIndex = this.prevVisibleIndexByIndex || this.nodeIds.reduce(function (acc, id, i) {
        var prevIndex = Math.max(i - 1, 0);
        acc[_this5.getNodeContext(id).absoluteIndex] = _this5.getNodeContext(_this5.nodeIds[prevIndex]).absoluteIndex;
        return acc;
      }, {});
      return this.prevVisibleIndexByIndex;
    }
  }, {
    key: "getNodeContext",
    value: function getNodeContext(id) {
      return this.nodeContextById[id];
    }
  }, {
    key: "getNodeCount",
    value: function getNodeCount() {
      this.nodeCount = typeof this.nodeCount === "number" ? this.nodeCount : Object.keys(this.nodeById).length;
      return this.nodeCount;
    }
  }, {
    key: "getLastVisibleIndex",
    value: function getLastVisibleIndex() {
      this.lastVisibleIndex = typeof this.lastVisibleIndex === "number" ? this.lastVisibleIndex : Math.max.apply(Math, _toConsumableArray(Object.values(this.getNextVisibleIndexByIndex())));
      return this.lastVisibleIndex;
    }
  }, {
    key: "getNextVisibleAbsoluteIndex",
    value: function getNextVisibleAbsoluteIndex(currentAbsoluteIndex) {
      return this.getNextVisibleIndexByIndex()[currentAbsoluteIndex];
    }
  }, {
    key: "getPrevVisibleAbsoluteIndex",
    value: function getPrevVisibleAbsoluteIndex(currentAbsoluteIndex) {
      return this.getPrevVisibleIndexByIndex()[currentAbsoluteIndex];
    }
  }, {
    key: "traverseDepthFirst",
    value: function traverseDepthFirst(iteratee) {
      var _this6 = this;

      this.rootIds.forEach(function (rootId) {
        iteratee(rootId, 0);

        _this6.getNodeContext(rootId).traverseDepthFirst(iteratee);
      });
    }
  }]);

  return TreeContext;
}();
function getTree(_ref3) {
  var filterBy = _ref3.filterBy,
      _ref3$hideBy = _ref3.hideBy,
      hideBy = _ref3$hideBy === void 0 ? function () {
    return false;
  } : _ref3$hideBy,
      _ref3$orderBy = _ref3.orderBy,
      orderBy = _ref3$orderBy === void 0 ? function () {
    return 0;
  } : _ref3$orderBy,
      nodeById = _ref3.nodeById;
  var hiddenIds = new Set();

  if (filterBy) {
    nodeById = filterWithAncestors(nodeById, function (id) {
      return filterBy({
        context: {
          id: id
        },
        node: nodeById[id]
      });
    });
  }

  var rootIds = Array.from(getRootIds(nodeById)).sort(function (a, b) {
    return orderBy({
      context: {
        id: a
      },
      node: nodeById[a]
    }, {
      context: {
        id: b
      },
      node: nodeById[b]
    });
  });

  if (rootIds.length === 0) {
    throw new Error("Tree must have a root");
  }

  var childIdsByParentId = getSortedChildIdsByParentId(getChildIdsByParentId(nodeById), function (a, b) {
    return orderBy({
      context: {
        id: a
      },
      node: nodeById[a]
    }, {
      context: {
        id: b
      },
      node: nodeById[b]
    });
  });
  var nodeIds = [];
  var nodes = [];
  var nodeContextById = {};
  var context = new TreeContext({
    hiddenIds: hiddenIds,
    nodeById: nodeById,
    nodeContextById: nodeContextById,
    nodeIds: nodeIds,
    nodes: nodes,
    childIdsByParentId: childIdsByParentId,
    rootIds: rootIds
  });
  var i = 0;
  rootIds.forEach(function (rootId) {
    return function getNodeRec(_ref4) {
      var ancestorIsLastChilds = _ref4.ancestorIsLastChilds,
          id = _ref4.id,
          parentId = _ref4.parentId;
      var node = nodeById[id];
      var isLastChild = parentId ? last(childIdsByParentId[parentId]) === id : true;
      ancestorIsLastChilds = [].concat(_toConsumableArray(ancestorIsLastChilds), [isLastChild]);
      nodeContextById[id] = new TreeNodeContext({
        absoluteIndex: i,
        hasDescenderByLevel: ancestorIsLastChilds.slice(1).map(function (ancestorIsLastChild, _i, col) {
          return _i === col.length - 1 ? true : !ancestorIsLastChild;
        }),
        id: id,
        parentId: node.parentId,
        ancestorIds: parentId ? [parentId].concat(_toConsumableArray(nodeContextById[parentId].ancestorIds)) : [],
        treeContext: context
      });
      i++;

      if (hideBy({
        context: {
          id: id
        },
        node: node
      })) {
        _traverseDepthFirst({
          id: id,
          childIdsByParentId: childIdsByParentId
        }, function (descendantId) {
          hiddenIds.add(descendantId);

          if (descendantId !== id) {
            nodeContextById[id] = new TreeNodeContext({
              absoluteIndex: i,
              hasDescenderByLevel: [],
              id: descendantId,
              parentId: node.parentId,
              ancestorIds: parentId ? [parentId].concat(_toConsumableArray(nodeContextById[parentId].ancestorIds)) : [],
              treeContext: context
            });
            i++;
          }
        });

        return;
      }

      nodes.push(node);
      nodeIds.push(id);
      childIdsByParentId[id].forEach(function (childId) {
        return getNodeRec({
          ancestorIsLastChilds: ancestorIsLastChilds,
          id: childId,
          parentId: id
        });
      });
    }({
      ancestorIsLastChilds: [],
      id: rootId
    });
  });
  return {
    context: context,
    nodes: nodes,
    nodeIds: nodeIds
  };
}

function filterWithAncestors(nodeById, predicate) {
  var acc = {};
  Object.keys(nodeById).forEach(function (id) {
    if (predicate(id)) {
      traverseUp({
        id: id,
        nodeById: nodeById
      }, function (ancestorId) {
        acc[ancestorId] = nodeById[ancestorId];
      });
    }
  });
  return acc;
}

function getChildIdsByParentId(nodeById) {
  var acc = {};

  for (var _i2 = 0, _Object$entries = Object.entries(nodeById); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        id = _Object$entries$_i[0],
        parentId = _Object$entries$_i[1].parentId;

    if (!acc[id]) {
      acc[id] = new Set();
    }

    if (parentId) {
      acc[parentId] = acc[parentId] || new Set();
      acc[parentId].add(id);
    }
  }

  return acc;
}

function getRootIds(nodeById) {
  var acc = new Set();

  for (var _i3 = 0, _Object$entries2 = Object.entries(nodeById); _i3 < _Object$entries2.length; _i3++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
        id = _Object$entries2$_i[0],
        foo = _Object$entries2$_i[1];

    if (!foo.parentId) {
      acc.add(id);
    }
  }

  return acc;
}

function getSortedChildIdsByParentId(childIdsByParentId, comparator) {
  var acc = {};

  for (var _i4 = 0, _Object$entries3 = Object.entries(childIdsByParentId); _i4 < _Object$entries3.length; _i4++) {
    var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i4], 2),
        id = _Object$entries3$_i[0],
        childIds = _Object$entries3$_i[1];

    acc[id] = Array.from(childIds).sort(comparator);
  }

  return acc;
}

function _traverseDepthFirst(_ref5, iteratee) {
  var id = _ref5.id,
      childIdsByParentId = _ref5.childIdsByParentId,
      _ref5$depth = _ref5.depth,
      depth = _ref5$depth === void 0 ? 0 : _ref5$depth;
  iteratee(id, depth);
  return childIdsByParentId[id].forEach(function (childId) {
    return _traverseDepthFirst({
      childIdsByParentId: childIdsByParentId,
      depth: depth + 1,
      id: childId
    }, iteratee);
  });
}

function traverseUp(_ref6, iteratee) {
  var id = _ref6.id,
      nodeById = _ref6.nodeById;
  var maxCount = Object.keys(nodeById).length;
  var count = 0;
  var ancestorId = nodeById[id] ? id : void 0;

  while (ancestorId) {
    var _nodeById$ancestorId;

    count++;

    if (count > maxCount) {
      throw new Error("Cannot traverse the tree because it has cycles");
    }

    iteratee(ancestorId);
    ancestorId = (_nodeById$ancestorId = nodeById[ancestorId]) === null || _nodeById$ancestorId === void 0 ? void 0 : _nodeById$ancestorId.parentId;
  }
}

export { TreeContext, TreeNodeContext, getTree };
